// 5218000953 ПЗ им. Ленина
// 5257117987 Моби
// 5245023068 Сильва
// 5262032016 Промис
// 5401342314 Авиакомпозит
// 5260266241 ЧОУ ДПО

import React, { FunctionComponent, useEffect, useRef, useState, useContext } from "react";
import * as XLSX from 'xlsx';
import { clearEmptyObjects, arrayContainCheck, formatNumberWithSpaces } from '../../utils/commonUtils';
import './Benchmarking.css';
import RivalsInnInput from "../RivalsInnInput/RivalsInnInput";
import Popup from '../Popup/Popup';
// import Carousel from '../Carousel/Carousel';
import Instruction from '../Instruction/Instruction';
import CustomizedDot from "../CustomizedDot/CustomizedDot";
import { fnsApi } from "../../utils/FnsApi";
import { FNS_KEY } from '../../constants/constants';
import { carouselData } from '../../constants/carouselData';
import { FnsDataManager } from "../../utils/FnsDataManager";

import { ComposedChart, LineChart, Line, BarChart, Bar, Rectangle, CartesianGrid, ReferenceLine, ResponsiveContainer, XAxis, YAxis, Tooltip, Legend } from 'recharts';

import addIcon from '../../images/add-icon.svg';
import addIconInactive from '../../images/add-icon-inactive.svg';
import visibilityIcon from '../../images/visibility-icon.svg';
import downloadIcon from '../../images/download-icon.svg';
import calendarIcon from '../../images/calendar-icon.svg';
import scaleIcon from '../../images/scale-icon.svg';
import instructionIcon from '../../images/instruction.svg';

function Benchmarking() {
  const [allCompanies, setAllCompanies] = useState([]);

  const [rivalsToShow, setRivalsToShow] = useState(() => {
    const savedRivals = JSON.parse(localStorage.getItem('rivalsToShow'));
    return savedRivals ? savedRivals : [];
  });

  const titles = {
    R: 'Рентабельность затрат',
    revenue: 'Выручка, тыс. руб.',
    profit: 'Прибыль от продаж, тыс. руб.',
    costs: 'Затраты, тыс. руб.',
    LP: 'Производительность труда, тыс. руб./чел.',
    staff: 'Среднесписочная численность, чел',
    ACPE: 'Удельные затраты на 1 сотрудника, тыс. руб./чел.',
  }

  const fnsDataManager = new FnsDataManager(fnsApi, FNS_KEY);

  const linesColours = [
    '#FFA500',  // Оранжевый
    '#800080',  // Фиолетовый
    '#0077b6',  // Синий
    '#753f13',  // Коричневый
    '#40E0D0',  // Бирюзовый
    '#000',  // Чёрный
  ]

  // --------------- ScaleLimit-Start ---------------
  const graphLimit = useRef(5000);
  const graphData = useRef([]);

  const [minScaleLimit, setMinScaleLimit] = useState(0);
  const [maxScaleLimit, setMaxScaleLimit] = useState(graphLimit.current);

  const maxScaleLimitRef = useRef(graphLimit.current);


  const scaleRevsAndCosts = useRef([]);
  const scaleLpAndAcpe = useRef([]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [isAnimated, setIsAnimated] = useState(true);

  function openPopup() {
    setIsPopupOpen(true);
  }

  function closePopup() {
    setIsPopupOpen(false);
  }

  function setBlur(evt) {
    if (evt.key === 'Enter') {
      evt.target.blur();
    }
  }

  function handleMinScaleLimit(evt) {
    const value = Number(evt.target.value);
    const limit = value === 0
      ? 0
      : Math.round(value / 500) * 500
    setMinScaleLimit(limit);
    document.querySelector('.benchmarking__scale_input_min').value = limit;
  }

  function handleMaxScaleLimit(evt) {
    const value = Number(evt.target.value);
    const limit = value === 0
      ? 0
      : Math.round(value / 500) * 500
    setMaxScaleLimit(limit);
    document.querySelector('.benchmarking__scale_input_max').value = limit;
  }

  const r1 = [
    {ACPE: 0, LP: 0},
    {ACPE: Math.max(maxScaleLimitRef.current, graphLimit.current), LP: Math.max(maxScaleLimitRef.current, graphLimit.current)},
  ];

  const r13 = [
    {ACPE: 0, LP: 0},
    {ACPE: Math.max(maxScaleLimitRef.current, graphLimit.current), LP: Math.max(maxScaleLimitRef.current, graphLimit.current)*1.3},
  ];
  // --------------- ScaleLimit-End ---------------

  // --------------- Years-Start ---------------
  const years = useRef([]);
  const [minYear, setMinYear] = useState();
  const [maxYear, setMaxYear] = useState();

  function handleMinYear(evt) {
    setMinYear(Number(evt.target.value));
  }

  function handleMaxYear(evt) {
    setMaxYear(Number(evt.target.value));
  }
  // --------------- Years-End ---------------


  function dataMixer(companyData) {
    const data = {
      inn: companyData.inn,
      name: companyData.name,
      years: [],
    };

    Object.keys(companyData.bo).forEach((key) => {
      const info = {};
      info.year = Number(key);
      (companyData.bo[key][2110] > 0) ? (info.revenue = companyData.bo[key][2110]*1) : (info.revenue = companyData.bo[key][6200]*1);
      const isObjectPresent = years.current.some(elem => elem === Number(key));
      (!isObjectPresent && info.revenue) && years.current.push(Number(key));

      info.costs = (
        (companyData.bo[key][2120] !== undefined ? Math.abs(companyData.bo[key][2120]*1) : 0) +
        (companyData.bo[key][2210] !== undefined ? Math.abs(companyData.bo[key][2210]*1) : 0) +
        (companyData.bo[key][2220] !== undefined ? Math.abs(companyData.bo[key][2220]*1) : 0));
      info.profit = companyData.bo[key][2200] !== undefined ? Math.abs(companyData.bo[key][2200]*1) : 0;
        if(companyData.staff.length > 0) {
        companyData.staff.find(obj => obj.year === Number(key))
        && (info.staff = companyData.staff.find(obj => obj.year === Number(key)).staff);
        info.LP = companyData.staff[key] !== 0 ? Number((Math.abs(companyData.bo[key][2110]*1) / info.staff).toFixed(0)) : 0;
        info.ACPE = companyData.staff[key] !== 0
        ? Number(((((companyData.bo[key][2120] !== undefined ? Math.abs(companyData.bo[key][2120]*1) : 0) +
        (companyData.bo[key][2210] !== undefined ? Math.abs(companyData.bo[key][2210]*1) : 0) +
        (companyData.bo[key][2220] !== undefined ? Math.abs(companyData.bo[key][2220]*1) : 0)) / info.staff).toFixed(0))) : 0;
      }
      data.years.push(info);
    })
    return data;
  }

  // function iterateOverLocalStorage() {
  //   for (let i = 0; i < localStorage.length; i++) {
  //     const key = localStorage.key(i); // Получаем ключ по индексу
  //     if (/^\d{10}$/.test(key)) { // Проверяем, состоит ли ключ из 10 цифр
  //       const value = JSON.parse(localStorage.getItem(key)); // Получаем значение по ключу
  //       console.log(`Ключ: ${key}, Значение:`, value); // Выводим ключ и значение
  //     }
  //   }
  // }
  // iterateOverLocalStorage();

  const [rChartTicks, setRChartTicks] = useState([]);

  function rChartTicksSetter() {
    const ticks = [minScaleLimit];
    const range = maxScaleLimitRef.current - minScaleLimit;

    let numOfTicks;
    let step;

    if (range > 7000) {
      if (range % 5000 === 0) {
        step = 2500;
      } else if (range % 3000 === 0) {
        step = 3000;
      } else if (range % 2000 === 0) {
        step = 2000;
      } else if (range % 1500 === 0) {
        step = 1500;
      } else if (range % 1000 === 0) {
        step = 1000;
      } else if (range % 500 === 0) {
        step = 1500;
      }
    } else {
      if (range % 1500 === 0) {
        step = 1500;
      } else if (range % 1000 === 0) {
        step = 1000;
      } else if (range % 500 === 0) {
        step = 500;
      }
    }
    numOfTicks = range / step;
      for (let i = 1; i <= numOfTicks; i++) {
          ticks.push(minScaleLimit + i * step);
      }
    setRChartTicks(ticks);
  }

  function allCompaniesAssembler() {
    const companies = [];
    if (rivalsToShow && rivalsToShow.length > 0) {
      rivalsToShow.forEach((rival) => {
          if (Object.keys(rival).length > 0) {
          const preparedRival = dataMixer(rival);
          if (preparedRival && !arrayContainCheck(companies, preparedRival)) {
            companies.push(preparedRival);
          }
        }
      });
    }
    setAllCompanies(companies);
  }

  function graphDataAssembler() {
    const newGraphData = [];

    allCompanies.length > 0 && allCompanies.forEach((company) => {
      if(!arrayContainCheck(graphData.current, company)) {
        const {name, inn} = company;
        const dataItem = {
          name: name,
          inn: Number(inn),
          data: [],
        }

        const minOfYears = minYear !== undefined
          ? Math.max(Math.min(...years.current), minYear)
          : Math.min(...years.current);
        const maxOfYears = maxYear !== undefined
          ? Math.min(Math.max(...years.current), maxYear)
          : Math.max(...years.current);
        document.querySelector('.benchmarking__rangeYear_input_min').value = minOfYears;
        document.querySelector('.benchmarking__rangeYear_input_max').value = maxOfYears;

        const filteredYears = company.years.filter(obj => obj.year >= minOfYears && obj.year<= maxOfYears);

        filteredYears.forEach((year) => {
          // const yearData = {
          //   inn: Number(inn),
          //   year: year.year,
          //   R: Number((year.LP / year.ACPE).toFixed(2)),
          //   revenue: year.revenue,
          //   profit: year.profit,
          //   costs: year.costs,
          //   LP: year.LP,
          //   staff: year.staff,
          //   ACPE: year.ACPE,
          // }

          const yearData = {
            inn: Number(inn),
            year: year.year,
            revenue: year.revenue,
            profit: year.profit,
            costs: year.costs,
          }

          if(year.staff !== undefined) {
            yearData.R = Number((year.LP / year.ACPE).toFixed(2));
            yearData.LP = year.LP;
            yearData.staff = year.staff;
            yearData.ACPE = year.ACPE;
          }

          const isPresent = dataItem.data.some(obj => obj.year === year.year);
          const hasNaN = Object.values(yearData).some(value => isNaN(value));
          (!isPresent && !hasNaN) && dataItem.data.push(yearData);
        });
        const isPresent = newGraphData.some(obj => obj.inn === company.inn);
        !isPresent && newGraphData.push(dataItem);
      }
    });
    graphData.current = newGraphData;
  }

  function graphLimiter() {
    const values = [];
    graphData.current.forEach((company) => {
      values.push(...company.data.map(obj => !isNaN(obj.ACPE) && obj.ACPE));
      values.push(...company.data.map(obj => !isNaN(obj.LP) && obj.LP));
    });

    let limit;
    values.length > 0 && (limit = Math.ceil(Math.max(...values)/1000)*1000 + 1000);

    if(limit !== undefined) {
      graphLimit.current = limit;
      maxScaleLimitRef.current = limit;
      setMaxScaleLimit(limit);
      document.querySelector('.benchmarking__scale_input_max').value = limit;
    }
  }

  function handleRivalDelete(evt) {
    const currentInput = evt.target.closest('.inputCard');
    const currentIndex = currentInput.id.split('_')[1];
    const updatedRivals = [...rivalsToShow];
    updatedRivals.splice(currentIndex, 1);
    setRivalsToShow(updatedRivals);
    localStorage.setItem(`rivalsToShow`, JSON.stringify(updatedRivals));
  }

  function CustomTooltip({ active, payload }) {

    if (active && payload !== undefined && payload[0]['payload'].inn) {
      const name = allCompanies.find(obj => obj.inn == payload[0]['payload'].inn).name;
      return (
        name &&  <div className="custom-tooltip">
          <p className="year">{`Компания: ${name}`}</p>
          <p className="year">{`ИНН: ${payload[0]['payload'].inn}`}</p>
          <p className="year">{`Год: ${payload[0]['payload'].year}`}</p>
          <p className="year">{`Рентабельность затрат (R): ${payload[0]['payload'].R}`}</p>
          <p className="year">{`Выручка: ${payload[0]['payload'].revenue && payload[0]['payload'].revenue.toLocaleString('ru-RU')} (тыс. руб.)`}</p>
          <p className="year">{`Затраты: ${payload[0]['payload'].costs && payload[0]['payload'].costs.toLocaleString('ru-RU')} (тыс. руб.)`}</p>
          <p className="year">{`Среднесписочная численность: ${payload[0]['payload'].staff && payload[0]['payload'].staff.toLocaleString('ru-RU')} (чел.)`}</p>
          <p className="year">{`Производительность труда: ${Math.round(payload[0]['payload'].LP).toLocaleString('ru-RU')} (тыс. руб./чел.)`}</p>
          <p className="year">{`Удельные затраты: ${Math.round(payload[0]['payload'].ACPE).toLocaleString('ru-RU')} (тыс. руб./чел.)`}</p>
          <p className="year">{`Прибыль от продаж: ${Math.round(payload[0]['payload'].profit).toLocaleString('ru-RU')} (тыс. руб.)`}</p>
        </div>
      );
    }
    return null;
  }

  // --------------- Grid-Chart-Start ---------------
  const gridChartsData = useRef([]);
  const rGraphLimitMin = useRef();
  const rGraphLimitMax = useRef();
  const keys = useRef([]);

  function gridChartsDataAssembler() {
    const newGraphData = [];

    graphData.current.length > 0 && graphData.current.forEach((company) => {
      const minOfYears = minYear !== undefined
          ? Math.max(Math.min(...years.current), minYear)
          : Math.min(...years.current);
        const maxOfYears = maxYear !== undefined
          ? Math.min(Math.max(...years.current), maxYear)
          : Math.max(...years.current);

      const filteredYears = company.data.filter(obj => obj.year >= minOfYears && obj.year<= maxOfYears);
      // const filteredYears = company.data.filter(obj => obj.year >= minYear && obj.year<= maxYear);

      filteredYears.forEach((year) => {
        const yearData = {
          year: year.year,
          r1: 1,
          r13: 1.3,
        }
        Object.keys(year).forEach((key) => {
          yearData[`${company.name}_${key}`] = year[key];
          const hasKey = keys.current.some(obj => obj === key);
          !hasKey && keys.current.push(key);
        })
        const hasYear = newGraphData.some(obj => obj.year === year.year);

        if(!hasYear) {
          newGraphData.push(yearData);
        } else {
          const foundYear = newGraphData.find(obj => obj.year === year.year);
          Object.keys(year).forEach((key) => {
            foundYear[`${company.name}_${key}`] = year[key];
          })
        }
      });
    });

    gridChartsData.current = newGraphData;
  }

  function rGraphGridLimiter() {
    const values = [];

    allCompanies.forEach((company) => {
      company.years.forEach((year) => {
        if(!isNaN(year.ACPE) && !isNaN(year.LP)) {
          values.push(Number((year.LP / year.ACPE).toFixed(2)));
          scaleLpAndAcpe.current.push(year.LP);
          scaleLpAndAcpe.current.push(year.ACPE);
          scaleRevsAndCosts.current.push(year.revenue);
          scaleRevsAndCosts.current.push(year.costs);
        }
      })
    });
    rGraphLimitMin.current = Number(Math.min(...values).toFixed(1)) - 0.1;
    rGraphLimitMax.current = Number(Math.max(...values).toFixed(1)) + 0.1;
  }

  function rGraphGridTickSetter() {
    const minTick = Number(Math.min(rGraphLimitMin.current, 1).toFixed(1));
    const maxTick = Number(Math.max(rGraphLimitMax.current, 1.3).toFixed(1));
    const ticks = [];
    for (let i = minTick; i <= maxTick; i = Number((i + 0.1).toFixed(1))) {
      ticks.push(i);
    }
    return ticks;
  }
  // --------------- Grid-Chart-End ---------------

  // --------------- Rival-Start ---------------
  // Temp array
  const addedRivals = [];
  // const rivalsLimit = 2;
  const rivalsLimit = 6;
  const [availableRivals, setAvailableRivals] = useState(rivalsLimit);
  const countINN = useRef();

  function addRival() {
    if(availableRivals > 0) {
      const newRival = {number: availableRivals};
      setRivalsToShow([...rivalsToShow, {}]);
      addedRivals.push(newRival);
      setAvailableRivals(availableRivals-1);
    }
  }

  function deleteRival(evt) {
    handleRivalDelete(evt);
    allCompaniesAssembler();
    graphLimiter();
    rChartTicksSetter();
    graphDataAssembler();
  }

  let lastRequestTime = 0; // Время последнего запроса
  const MIN_REQUEST_INTERVAL = 1000; // Минимальный интервал между запросами (в миллисекундах)
  const MAX_REQUESTS_PER_HOUR = 10; // Максимум запросов в час

  function isRequestAllowed() {
    const now = Date.now();

    if (now - lastRequestTime < MIN_REQUEST_INTERVAL) {
        alert("Слишком много запросов! Пожалуйста, подождите.");
        return false;
    }

    const hourKey = new Date().toISOString().split('T')[0] + 'T' + new Date().getHours();
    const requestCount = parseInt(localStorage.getItem(`hourlyRequests:${hourKey}`)) || 0;

    if (requestCount >= MAX_REQUESTS_PER_HOUR) {
        alert("Вы достигли лимита запросов на этот час!");
        return false;
    }

    lastRequestTime = now;
    localStorage.setItem(`hourlyRequests:${hourKey}`, (requestCount + 1).toString());

    return true;
  }

  async function addRivalsToCompanyObject(inn) {
    console.log('inn', inn);

    if(inn !== null || undefined) {
      let rival;
      const localObject = JSON.parse(localStorage.getItem(`${inn}`));
      if (localObject) {
        rival = localObject;
      } else {
        if (!isRequestAllowed()) return;
        try {
          const newRival = await fnsDataManager.makeFnsDataObject(inn);
          localStorage.setItem(`${inn}`, JSON.stringify(newRival));
          rival = newRival;
        } catch (error) {
          console.error('Error creating new rival:', error);
        }
      }
      console.log('rivalsToShow', rivalsToShow);

      const rivalsToShowNotEmpty = clearEmptyObjects(rivalsToShow);
      const hasRival = rivalsToShowNotEmpty.some(obj => obj === rival);
      !hasRival && rivalsToShowNotEmpty.push(rival);
      setRivalsToShow(rivalsToShowNotEmpty);
      console.log('rivalsToShowNotEmpty', rivalsToShowNotEmpty);
      localStorage.setItem(`rivalsToShow`, JSON.stringify(rivalsToShowNotEmpty));
      allCompaniesAssembler();
      graphLimiter();
      rChartTicksSetter();
      graphDataAssembler();
      gridChartsDataAssembler();
    }
  }

  async function handleRivalSelection(inn) {
    addRivalsToCompanyObject(inn);
  };
  // --------------- Add-Rival-End ---------------

  // --------------- ExportToExcel-Start ---------------
  function exportToExcel(jsonData) {
    const worksheet = XLSX.utils.json_to_sheet(jsonData.flatMap(item =>
      item.years.map(year => ({
        inn: item.inn,
        name: item.name,
        year: year.year,
        staff: year.staff,
        revenue: year.revenue || '',
        costs: year.costs,
        LP: year['LP'] || '',
        ACPE: year['ACPE'] || '',
        profit: year.profit,
        ...year
      }))
    ));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Данные');

    XLSX.writeFile(workbook, 'data.xlsx');
  };

  function exportDataExtender (allCompanies) {
    // const extendedData = [];

    allCompanies.forEach(company => {
      const localData = JSON.parse(localStorage.getItem(`${company.inn}`));
      console.log('localData.bo', localData.bo);
      company.years.forEach(year => {
        const exactData = localData.bo[year.year];
        let extended = {};
        Object.keys(exactData).forEach(key => {
          extended[key] = Number(exactData[key]);
        })
        console.log('extended', extended);
        console.log('newYear', Object.assign(year, extended));
      })
    });
    return allCompanies;
  }

  function handleExport() {
    exportToExcel(exportDataExtender(allCompanies));
    // exportToExcel(allCompanies);
    // exportDataExtender(allCompanies);
    console.log('allCompanies', allCompanies);
  }
  // --------------- ExportToExcel-End ---------------

  // --------------- Carousel-Start ---------------
  // const carouselData = [
  //   {
  //     image: 'data:image/jpeg;base64,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',
  //     caption: 'Подпись к изображению 1',
  //     link: 'https://centr-prioritet.ru/company/news/314-novosti-soobshchestva/4350-apqp-3-e-izdanie-2024'
  //   },
  //   {
  //     image: 'data:image/jpeg;base64,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',
  //     caption: 'Подпись к изображению 2',
  //     link: 'https://www.centr-prioritet.ru'
  //   },
  // ];
  // --------------- Carousel-End ---------------

  // --------------- UseEffect-Start ---------------
  useEffect(() => {
    if(years.current.length > 0) {
      setMinYear(Math.min(...years.current));
      setMaxYear(Math.max(...years.current));
      document.querySelector('.benchmarking__rangeYear_input_min').value = Math.min(...years.current);
      document.querySelector('.benchmarking__rangeYear_input_max').value = Math.max(...years.current);
    }
    allCompaniesAssembler();
    graphDataAssembler();
    graphLimiter();
    gridChartsDataAssembler();
    rGraphGridLimiter();
    rGraphGridTickSetter()
    rChartTicksSetter();
    setMaxScaleLimit(maxScaleLimitRef.current);
  }, [])

  useEffect(() => {
    allCompaniesAssembler();
    setAvailableRivals(rivalsLimit - rivalsToShow.length);
    const addButton = document.querySelector('.benchmarking__addRivalBtn');
    availableRivals < 1
      ? (addButton.disabled = true)
      : (addButton.disabled = false);
  }, [rivalsToShow]);

  useEffect(() => {
    graphDataAssembler();
    graphLimiter();
    gridChartsDataAssembler();
    rGraphGridLimiter();
    rGraphGridTickSetter()
    rChartTicksSetter();
    console.log('rivalsToShow', rivalsToShow);

  }, [allCompanies, minYear, maxYear]);

  useEffect(() => {
    maxScaleLimitRef.current = maxScaleLimit;
    rChartTicksSetter();
  }, [minScaleLimit, maxScaleLimit]);
  // --------------- UseEffect-End ---------------

  return(
    <main className="benchmarking" >
      <header className="benchmarking__header">
        <h1 className="benchmarking__title">КАРТА ОПЕРАЦИОННОЙ ЭФФЕКТИВНОСТИ</h1>
        <div className="benchmarking__logo"></div>
      </header>
      <div className="benchmarking__main">
        <section className="benchmarking__chartSection">
          <div className="benchmarking__chartFrame frame">
            <div className="benchmarking__chart">
              <LineChart
                width={750} height={600}
                margin={{ top: 10, right: 50, left: 50}}
              >
                <CartesianGrid strokeDasharray="3" />
                <YAxis
                  dataKey="LP"
                  domain={[
                    minScaleLimit, maxScaleLimitRef.current
                  ]}
                  type="number"
                  tickFormatter={formatNumberWithSpaces}
                  interval={0}
                  label={{
                    value: `Производительность труда, тыс. руб./чел. (Выручка/ССЧ)`,
                    style: { textAnchor: 'middle' },
                    angle: -90,
                    position: 'left',
                    offset: 0,
                    fontSize: 18,
                  }}
                  width={80}
                  allowDataOverflow={true}
                  strokeWidth={1}
                  ticks={rChartTicks}
                />
                <XAxis
                  dataKey="ACPE"
                  domain={[
                    minScaleLimit, maxScaleLimitRef.current
                  ]}
                  tickFormatter={formatNumberWithSpaces}
                  interval={0}
                  type="number"
                  label={{
                    value: `Удельные затраты на 1 сотрудника, тыс. руб./чел. (Затраты/ССЧ)`,
                    style: { textAnchor: 'middle' },
                    offset: 0,
                    fontSize: 18,
                  }}
                  height={75}
                  allowDataOverflow={true}
                  strokeWidth={1}
                  ticks={rChartTicks}
                />
                {/* <Legend wrapperStyle={{ top: 40, right: 20 }} /> */}
                <Line
                  strokeWidth={2}
                  isAnimationActive={isAnimated}
                  data={r1}
                  name={'R=1,0'}
                  dot={false}
                  activeDot={false}
                  type="monotone"
                  dataKey="LP"
                  stroke="#FF0000"
                  strokeDasharray="9"
                  tooltipType="none"
                />
                <Line
                  strokeWidth={2}
                  isAnimationActive={isAnimated}
                  data={r13}
                  name={'R=1,3'}
                  dot={false}
                  activeDot={false}
                  type="monotone"
                  dataKey="LP"
                  stroke="#008000"
                  strokeDasharray="9"
                  tooltipType="none"
                />
                {graphData.current.length > 0 && graphData.current.map((item, index) => {
                  const years = item.data.map(obj => obj.year);
                  return (
                    <Line
                      key={item.name}
                      isAnimationActive={false}
                      // isAnimationActive={isAnimated}
                      strokeWidth={2}
                      name={item.name}
                      unit={item.inn}
                      data={item.data}
                      dot={<CustomizedDot
                        years={years}
                      />}
                      type="default"
                      dataKey="LP"
                      stroke={linesColours[index]}
                      activeDot={false}
                    />
                  )})
                }
                <Tooltip content={<CustomTooltip />} />
              </LineChart>
            </div>
          </div>
          <div className="chartGrid">
            {/* {(gridChartsData.current.length > 0 && graphData.current.length > 0) && Object.keys(graphData.current.reduce((maxObj, currentCompany) => {
              const maxDataObject = currentCompany.data.reduce((maxData, currentData) => {
                console.log('maxData', maxData);
                console.log('currentData', currentData);
                console.log('maxObj', maxObj);
                console.log('maxDataObject', maxDataObject);

                return Object.keys(currentData).length > Object.keys(maxData).length ? currentData : maxData;
              });
              return Object.keys(maxDataObject).length > Object.keys(maxObj).length ? maxDataObject : maxObj;
            }, {})).map((key) => { */}
            {(gridChartsData.current.length > 0 && graphData.current.length > 0) && keys.current.map((key) => {
              if(key !== 'inn' && key !== 'year') {
              const split = titles[key].split(', ');
                return (
                  <div className="chartGrid__chartFrame frame">
                    <div className="chartGrid__chart" >
                      <h3 className="chartGrid__title">
                        <span>{split[0]} </span>
                        {(key === 'LP' || key === 'ACPE') && <br />}
                        {key !== 'R' && <span>({split[1]})</span>}
                      </h3>
                      {(key !== 'LP' && key !== 'ACPE') && <br />}
                      <ComposedChart
                        width={346}
                        height={300}
                        data={gridChartsData.current}
                        margin={{
                          top: 5,
                          right: 20,
                          left: 25,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="year" />
                        <YAxis
                          domain={
                            key === 'R' && [rGraphLimitMin.current, rGraphLimitMax.current]
                            // : key === ('LP' || 'ACPE') ? [Math.min(...scaleLpAndAcpe.current), Math.max(...scaleLpAndAcpe.current)]
                            // : key === ('revenue' || 'costs') && [Math.min(...scaleRevsAndCosts.current), Math.max(...scaleRevsAndCosts.current)]
                          }
                          tickFormatter={formatNumberWithSpaces}
                          ticks={
                            key === 'R' && rGraphGridTickSetter()
                            // key === 'R' && [1, 1.15, 1.3, rGraphLimitMin.current, rGraphLimitMax.current].sort()
                          }
                          width={75}
                        />
                        <Tooltip formatter={(value) => formatNumberWithSpaces(value)} />
                        {/* <Legend /> */}
                        {key === 'R' && <Line
                          strokeWidth={2}
                          isAnimationActive={isAnimated}
                          name={'R=1,0'}
                          dot={false}
                          activeDot={false}
                          type="monotone"
                          dataKey="r1"
                          stroke="#FF0000"
                          strokeDasharray="9"
                          tooltipType="none"
                        />}
                        {key === 'R' && <Line
                          strokeWidth={2}
                          isAnimationActive={isAnimated}
                          name={'R=1,3'}
                          dot={false}
                          activeDot={false}
                          type="monotone"
                          dataKey="r13"
                          stroke="#008000"
                          strokeDasharray="9"
                          tooltipType="none"
                        />}
                        {allCompanies.map((item, index) => {
                          return (
                            <Line
                              dataKey={`${item.name}_${key}`}
                              isAnimationActive={isAnimated}
                              name={item.name}
                              stroke={linesColours[index]}
                              strokeWidth={3}
                            />
                          )})}
                      </ComposedChart>
                    </div>
                  </div>
                )
              }
            })}
          </div>
        </section>
        <section className="benchmarking__legendSection">
          {/* <Carousel data={carouselData} /> */}
          <form className="benchmarking__rivalsForm frame">
            <div className="benchmarking__formButtons">
              <button type="button" className={`benchmarking__addRivalBtn button button button__wide ${availableRivals > 0 ? 'button__add' : 'button__inactive'}`} onClick={addRival}  >
                <img src={availableRivals > 0 ? addIcon : addIconInactive} alt="" className="button__icon" />
                <p className="button__title">ДОБАВИТЬ</p>
              </button>
              {/* <button type="submit" className="benchmarking__submit button">
                <img src={visibilityIcon} alt="" className="button__icon" />
                <p className="button__title">ПОКАЗАТЬ</p>
              </button> */}
            </div>
            <button type="button" onClick={handleExport} className="button button__wide">
              <img src={downloadIcon} alt="" className="button__icon" />
              <p className="button__title">ЭКСПОРТИРОВАТЬ ДАННЫЕ</p>
            </button>
            <div className="area benchmarking__rivalsArea">
              <h2 className="benchmarking__rivalsTitle">ОРГАНИЗАЦИИ</h2>
              <ul className="benchmarking__list">
                {rivalsToShow !== undefined && (rivalsToShow.map((rival, index) => {
                  return(
                    <li key={rival.inn} className="benchmarking__rivalItem">
                      <RivalsInnInput  inn={rival.inn} name={rival.name} rival={rival} index={rivalsToShow.indexOf(rival)} colour={linesColours[index]} deleteRival={deleteRival} handleRivalSelection={handleRivalSelection} />
                    </li>
                  );
                }))}
              </ul>
            </div>
            <div className="area benchmarking__rLinesLegend">
              <ul className="benchmarking__list benchmarking__list_type_rLines">
                <li className="benchmarking__rLegendUnit">
                  <div className="benchmarking__rLegendUnitLine benchmarking__rLegendUnitLine_type_r13"></div>
                  <h2 className="benchmarking__rLegendUnitTitle">Рентабельность затрат (R) = 1.3</h2>
                </li>
                <li className="benchmarking__rLegendUnit">
                  <div className="benchmarking__rLegendUnitLine benchmarking__rLegendUnitLine_type_r1"></div>
                  <h2 className="benchmarking__rLegendUnitTitle">Рентабельность затрат (R) = 1</h2>
                </li>
              </ul>
            </div>
            <div className="area benchmarking__rangeArea">
              <div className="benchmarking__range">
                <label className="benchmarking__range_label_min" htmlFor="min">
                  <img className="benchmarking__rangeIcon" src={calendarIcon} alt="" />
                  <p className="benchmarking__rangeName">ПЕРИОД</p>
                </label>
                <div className="benchmarking__rangeInputs">
                  <input className="benchmarking__range_input benchmarking__range_input_min benchmarking__rangeYear_input_min" type="number" name="min" onKeyDown={setBlur} onBlur={handleMinYear}/>
                  <label className="benchmarking__range_label_max" htmlFor="max" >&#8211;</label>
                  <input className="benchmarking__range_input benchmarking__range_input_max benchmarking__rangeYear_input_max" type="number" name="max" onKeyDown={setBlur} onBlur={handleMaxYear}/>
                </div>
              </div>
              <div className="benchmarking__range">
              <label className="benchmarking__range_label_min" htmlFor="min">
                  <img className="benchmarking__rangeIcon" src={scaleIcon} alt="" />
                  <p className="benchmarking__rangeName">ШКАЛА</p>
                </label>
                <div className="benchmarking__rangeInputs">
                  <input className="benchmarking__range_input benchmarking__range_input_min benchmarking__scale_input_min" type="number" name="min" defaultValue={0} onKeyDown={setBlur} onBlur={handleMinScaleLimit}/>
                  <label className="benchmarking__range_label_max" htmlFor="max" >&#8211;</label>
                  <input className="benchmarking__range_input benchmarking__range_input_max benchmarking__scale_input_max" type="number" name="max" defaultValue={graphLimit.current} onKeyDown={setBlur} onBlur={handleMaxScaleLimit} />
                </div>
              </div>
            </div>
            <button type="button" className="button button__wide" onClick={openPopup}>
              <img src={instructionIcon} alt="" className="button__icon" />
              <p className="button__title">КАК ИНТЕРПРЕТИРОВАТЬ</p>
            </button>
          </form>
          <p className="benchmarking__notification">Данные взяты из базы данных ФНС. Подробнее см. <a href="https://api-fns.ru/">api-fns.ru/</a></p>
        </section>
        <section className="instructionPopup popup">
          <div className="popup__overlay"></div>
          <div className="popup__card"></div>
        </section>
      </div>
      <Popup isPopupOpen={isPopupOpen} closePopup={closePopup}>
        <>
          <Instruction/>
        </>
      </Popup>
    </main>
  )
}

export default Benchmarking;
